import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CategoriesResDto } from '../_dtos/categoriesResDto';
import { CategoryResDto } from '../_dtos/categoryResDto';

interface CategoryQueryParams {
  type?: string;
  name?: string;
}

@Injectable({
  providedIn: 'root',
})
export class CategoriesService {
  private readonly apiUrl = `${environment.backendBaseUrl}/categories`;
  private spCategories = new BehaviorSubject<CategoryResDto[] | null>(null);
  private teamCategories = new BehaviorSubject<CategoryResDto[] | null>(null);

  sharepointCategories$ = this.spCategories.asObservable();
  teamCategories$ = this.teamCategories.asObservable();

  constructor(private http: HttpClient) {}

  getCategory(queryParams?: CategoryQueryParams): Observable<CategoriesResDto> {
    let params = new HttpParams();

    if (queryParams?.type) params = params.set('type', queryParams.type);

    if (queryParams?.name) params = params.set('name', queryParams.name);

    return this.http.get<CategoriesResDto>(`${this.apiUrl}`, { params });
  }

  getSpCategories(): CategoryResDto[] {
    const spCategories = this.spCategories.getValue();
    if (!spCategories)
      throw new Error('Attempted to access spCategories before it was loaded');

    return spCategories;
  }

  setSharepointCategories(categories: CategoryResDto[]) {
    this.spCategories.next(categories);
  }

  getTeamCategories(): CategoryResDto[] {
    const teamCategories = this.teamCategories.getValue();
    if (!teamCategories)
      throw new Error(
        'Attempted to access teamCategories before it was loaded',
      );

    return teamCategories;
  }

  setTeamCategories(categories: CategoryResDto[]) {
    this.teamCategories.next(categories);
  }
}
